// extracted by mini-css-extract-plugin
export var linkText = "_lq-0";